module.exports = __webpack_public_path__ + "img/img_8.b03946b7.svg";